import React from 'react';

type CardProps = {
    title: string;
    subtitle: string;
    image: string;
    alt?: string;
};

export function BenefitCard({ title, subtitle, image, alt = '' }: CardProps) {
    const imageStyle = image ? { backgroundImage: `url(${image})` } : { backgroundColor: 'rgba(0,0,0,0.04)' };

    return (
        <article className="googlelp-benefit-card flex flex-column" aria-label={title}>
            <div className="googlelp-benefit-card-top flex text-center flex-column justify-center px-3 py-4 p-md-5">
                <h3 className="googlelp-benefit-card-title mb-0 mcl-font-proxima">{title}</h3>
                {subtitle && <p className="googlelp-benefit-card-sub mcl-font-proxima mb-0">{subtitle}</p>}
            </div>
            <div
                className="googlelp-benefit-card-image"
                style={imageStyle}
                role={image ? 'img' : undefined}
                aria-label={image && alt ? alt : undefined}
            />
        </article>
    );
}

export default BenefitCard;
